import { cn } from '@/utils/cn.utils';
import { forwardRef } from 'react';

export const Tag = forwardRef<HTMLDivElement, React.PropsWithChildren<{ className?: string }>>(
  ({ children, className }, ref) => {
    const classes = cn(
      'text-orange border-orange/25 bg-orange/5 font-roboto-medium inline-block w-fit rounded-md px-2.5 py-1 text-sm',
      className,
    );

    return (
      <div ref={ref} className={classes}>
        {children}
      </div>
    );
  },
);
